<template>
  <form>
    <div v-for="(item) in items" class="mdn-CardInstitutional border-red-500 mdn-CardInstitutional--default w-full mt-5" :key="item.id">
      <div class="mdn-CardInstitutional-content w-full flex flex-row justify-between">
        <div class="flex flex-row mdn-Radio justify-center items-center">
          <input
            v-model="picked"
            @change="onPicked"
            :id="item.value"
            :for="item.value"
            :value="item.value"
            name="generic"
            type="radio"
            class="mdn-Radio-input"
            aria-label="Radio button">
          <label class="mdn-Radio-label" :for="item.value"></label>
          <div class="mdn-Radio-text" :for="item.value">{{item.name}}</div>
        </div>
        <BrandIconMdn
          class="w-8"
          :brandName="item.bandeira"
        />
      </div>
      <div v-if="item.value == picked">
        <slot name="MdnRadio_Content"></slot>
      </div>
    </div>
  </form>
</template>

<script>
import BrandIconMdn from './BrandIconMdn.vue'

export default {
  name: 'MdnRadio',
  components: { BrandIconMdn },
  data: () => ({
    picked: undefined
  }),
  props: {
    items: Array,
    defaultValue: String
  },
  emits: ['picked'],
  methods: {
    onPicked (event) {
      this.$emit('picked', event.target.value)
    }
  },
  mounted () {
    this.picked = this.defaultValue ?? undefined
  }
}
</script>
